/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type ListBuiltinExclusionsSecurityOption1 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type ListBuiltinExclusionsSecurityOption2 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type ListBuiltinExclusionsSecurity = {
  option1?: ListBuiltinExclusionsSecurityOption1 | undefined;
  option2?: ListBuiltinExclusionsSecurityOption2 | undefined;
};

export type ListBuiltinExclusionsRequest = {
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type ListBuiltinExclusionsSecurityOption1$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const ListBuiltinExclusionsSecurityOption1$outboundSchema: z.ZodMiniType<
  ListBuiltinExclusionsSecurityOption1$Outbound,
  ListBuiltinExclusionsSecurityOption1
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function listBuiltinExclusionsSecurityOption1ToJSON(
  listBuiltinExclusionsSecurityOption1: ListBuiltinExclusionsSecurityOption1,
): string {
  return JSON.stringify(
    ListBuiltinExclusionsSecurityOption1$outboundSchema.parse(
      listBuiltinExclusionsSecurityOption1,
    ),
  );
}

/** @internal */
export type ListBuiltinExclusionsSecurityOption2$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const ListBuiltinExclusionsSecurityOption2$outboundSchema: z.ZodMiniType<
  ListBuiltinExclusionsSecurityOption2$Outbound,
  ListBuiltinExclusionsSecurityOption2
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function listBuiltinExclusionsSecurityOption2ToJSON(
  listBuiltinExclusionsSecurityOption2: ListBuiltinExclusionsSecurityOption2,
): string {
  return JSON.stringify(
    ListBuiltinExclusionsSecurityOption2$outboundSchema.parse(
      listBuiltinExclusionsSecurityOption2,
    ),
  );
}

/** @internal */
export type ListBuiltinExclusionsSecurity$Outbound = {
  Option1?: ListBuiltinExclusionsSecurityOption1$Outbound | undefined;
  Option2?: ListBuiltinExclusionsSecurityOption2$Outbound | undefined;
};

/** @internal */
export const ListBuiltinExclusionsSecurity$outboundSchema: z.ZodMiniType<
  ListBuiltinExclusionsSecurity$Outbound,
  ListBuiltinExclusionsSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => ListBuiltinExclusionsSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => ListBuiltinExclusionsSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function listBuiltinExclusionsSecurityToJSON(
  listBuiltinExclusionsSecurity: ListBuiltinExclusionsSecurity,
): string {
  return JSON.stringify(
    ListBuiltinExclusionsSecurity$outboundSchema.parse(
      listBuiltinExclusionsSecurity,
    ),
  );
}

/** @internal */
export type ListBuiltinExclusionsRequest$Outbound = {
  "Gram-Key"?: string | undefined;
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const ListBuiltinExclusionsRequest$outboundSchema: z.ZodMiniType<
  ListBuiltinExclusionsRequest$Outbound,
  ListBuiltinExclusionsRequest
> = z.pipe(
  z.object({
    gramKey: z.optional(z.string()),
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramKey: "Gram-Key",
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
    });
  }),
);

export function listBuiltinExclusionsRequestToJSON(
  listBuiltinExclusionsRequest: ListBuiltinExclusionsRequest,
): string {
  return JSON.stringify(
    ListBuiltinExclusionsRequest$outboundSchema.parse(
      listBuiltinExclusionsRequest,
    ),
  );
}
